import { Dayjs } from 'dayjs';
import { IClientDomain, ISelectData, TBillingStatus } from './Billing';
import {
	IClaimNetwork,
	IClaimStatus,
	INetworkStatus,
	IReturnStatus,
} from './Claims';
import { IComplaintPicklist } from './ComplaintTracking';

export interface IBaseFilterState {
	errorCode: number;
	errorMessage: string;
	size: number;
	search: boolean;
	searchCheckElegibility: string;
	buttonSearchCheckElegibility: boolean;
}

export interface IInputFilterState {
	inputFiscalCode: string;
	inputMemberId: string;
	inputFirstName: string;
	inputLastName: string;
	inputDateOfBirth: Dayjs | null;
	dateOfService: Dayjs | null;
	filterDateOfService: Dayjs | null;
	inputExternalClaimId: string;
	inputCarrierClaimId: string;
	inputClaimFirstName: string;
	inputClaimLastName: string;
	inputClaimStartDate: Dayjs | null;
	inputClaimEndDate: Dayjs | null;
	inputPaidStartDate: Dayjs | null;
	inputPaidEndDate: Dayjs | null;
	inputClaimStatus: string;
	inputReferenceNumber: number | null;
	inputTotalAmount: number | null;
	inputBillingId: string;
	inputBillingCarriers: string[];
	inputBillingMarkets: string[];
	inputClients: string[];
	inputGroups: string[];
	inputBillingTypologies: string[];
	inputBillingStatus: TBillingStatus;
	inputBillingStartDate: string | null;
	inputBillingEndDate: string | null;
	inputClaimBillingStartDate: Dayjs | null;
	inputClaimBillingEndDate: Dayjs | null;
	inputClaimSettlementStartDate: Dayjs | null;
	inputClaimSettlementEndDate: Dayjs | null;
	inputClaimNumber: string;
	inputSettlementLettersCarriers: string[];
	inputSettlementLettersStartDate: string | null;
	inputSettlementLettersEndDate: string | null;
	sortingFields: string;
	sortingDirections: string;
	carriers: ISelectData[];
	groups: ISelectData[];
	claimsStatuses: IClaimStatus[];
	claimClients: ISelectData[];
	claimClientsDomain: IClientDomain[];
	claimNetworkStatuses: INetworkStatus[];
	claimReturnStatuses: IReturnStatus[];
	networks: IClaimNetwork[];
	relationshipTypes: ISelectData[];
	inputClient: string;
	inputClaimNetworkStatus: string;
	inputClaimReturnStatus: string;
	inputBillingNetworkStatus: string;
	inputHasComplaint: string;
	inputHasFraud: string;
	inputMemberLocation: string;
	inputClaimMarkets: string[];
	fraudStatuses: IComplaintPicklist[];
	inputMemberBillingId: string;
	inputMemberBillingStatus: string;
	inputMemberBillingMonthStart: Dayjs | null;
	inputMemberBillingMonthEnd: Dayjs | null;
	inputMemberClient: string[];
	inputMemberGroups: string[];
	inputMemberPlanCodes: string[];
	// Aggregation-specific duplicates (independent from member filters)
	inputAggregationBillingMonthStart: Dayjs | null;
	inputAggregationBillingMonthEnd: Dayjs | null;
	inputAggregationClient: string[];
	inputAggregationGroups: string[];
	inputAggregationPlanCodes: string[];
	inputMemberDivisionCode: string;
	inputMemberLastName: string;
	inputMemberFirstName: string;
	inputMemberRelationshipTypes: string[];
	inputMemberMemberId: string;
	inputMemberEmMemberId: string;
	inputMemberSubscriptionStartDate: Dayjs | null;
	inputMemberSubscriptionEndDate: Dayjs | null;
	inputFraudId: string;
	inputDetectionDate: Dayjs | null;
	inputReferralDate: Dayjs | null;
	inputInvestigationStatus: string;
	complaintStatuses: IComplaintPicklist[];
	complaintSources: IComplaintPicklist[];
	complaintTypes: IComplaintPicklist[];
	inputComplaintId: string;
	inputClaimId: string;
	inputComplaintSource: string;
	inputComplaintType: string;
	inputComplaintNotificationDate: Dayjs | null;
	inputComplaintStatus: string;
	inputComplaintOutcome: string;
	inputComplaintClosureDate: Dayjs | null;
	inputFRLSent: string;
	inputFRLSentDate: Dayjs | null;
}

export interface IFilterState extends IBaseFilterState, IInputFilterState {}

export interface IState {
	errorCode: number;
	errorMessage: string;
}

export enum OptionsDatepicker {
	margin = 'margin',
	field = 'field',
}

export type TInputStateSlice = {
	reasonNote?: string | null;
	reasonCode?: string | null;
	denialArticle?: string | null;
	denialNumArticle?: string | null;
};

export enum sortingDirections {
	DESC = 'DESC',
	ASC = 'ASC',
}
